import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from "../contexts/AuthContext";
import { CFormInput, CTable, CTableDataCell, CTableHeaderCell, CTableBody, CTableRow, CTableHead, CModal, CTooltip, CModalBody, CButton } from '@coreui/react'
import axios from 'axios'
import ReactLoading from 'react-loading';
import './Bebidas.css'
import InsertBebida from './InsertBebida'
import EditBebida from './EditBebida'
import Swal from 'sweetalert2';

function Bebidas() {
    let { user1 } = useContext(AuthContext);
    let [loading, setLoading] = useState(true)
    let [bebidasOG, setBebidasOG] = useState([])
    let [bebidas, setBebidas] = useState([])
    let [allDrinks, setAllDrinks] = useState([])
    // let [visible, setVisible] = useState(false)
    let [visible2, setVisible2] = useState(false)
    let [visible3, setVisible3] = useState(false)
    let [infoEdit, setInfoEdit] = useState({})
    let [infoEditOG, setInfoEditOG] = useState({})
    // let [fotoModal, setFotoModal] = useState("")
    let [editandoArray, setEditandoArray] = useState(false)
    let [dragIndex, setDragIndex] = useState(null);

    const excludeColumns = ["_id", "is_active", "createdAt", "updatedAt"]; // excluye datos del arreglo donde se buscara

    function getBebidas() {

        if (user1.role == 'restaurant') {
            axios.get(`${process.env.REACT_APP_BackURL}/getRestaurantById?id=${user1.id}&all=true`)
                .then((response) => { setBebidas(response.data.data.drinks); setBebidasOG(response.data.data.drinks); setLoading(false) })
                .catch((err) => { console.log(err) })
        }

        axios.get(`${process.env.REACT_APP_BackURL}/getAllDrinks`)
            .then((response) => {
                if (user1.role == 'master') {
                    setBebidas(response.data.data);
                    setBebidasOG(response.data.data);
                }
                setAllDrinks(response.data.data)
                setLoading(false)
            })
            .catch((err) => { console.log(err) })

    }

    function statusBebida(item, status) {
        Swal.fire({
            icon: 'warning',
            title: '¿Estas seguro?',
            text: `Vas a cambiar el stastus de la bebida ${item.name} a ${status ? "visible" : "oculto"} en la app`,
            showCancelButton: true,
            confirmButtonColor: '#46eb34',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, cambiar',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios.patch(`${process.env.REACT_APP_BackURL}/updateDrinkById?id=${item._id}`, { isActive: status })
                        .then((response) => {
                            Swal.fire({
                                icon: 'success',
                                title: 'Bebida actualizada con exito',
                                timerProgressBar: true,
                                allowEscapeKey: true
                            })
                                .then((result) => { if (result.isConfirmed) { getBebidas() } })
                        })
                        .catch((err) => { console.log(err) })
                }
            })
    }

    // handle change event of search input
    function handleChange(value) {
        filterData(value);
    };

    // filter records by search text
    function filterData(value) {
        const searchTerms = value.toLowerCase().trim().split(/\s+/); // Divide por espacios
        if (searchTerms.length === 1 && searchTerms[0] === "") {
            setBebidas(bebidasOG);
            return;
        }

        const filteredData = bebidasOG.filter((item) => {
            // Verifica cada término de búsqueda en los campos no excluidos
            return searchTerms.every(term => {
                return Object.keys(item).some((key) => {
                    if (excludeColumns.includes(key)) return false;
                    return item[key].toString().toLowerCase().includes(term);
                });
            });
        });
        setBebidas(filteredData);
    };

    function handleUpdateOrder() {
        // verifico si el array de bebidas ha cambiado
        const huboCambios = JSON.stringify(bebidas) !== JSON.stringify(bebidasOG)
        let payload = []
        if (!huboCambios) {
            return
        } else {
            payload = bebidas.map((bebida) => bebida._id)
            if (payload.length > 0) {
                axios.patch(`${process.env.REACT_APP_BackURL}/updateRestaurantById?id=${user1.id}`, { drinks: payload })
                    .then((response) => { Swal.fire("Bebidas ordenadas con éxito").then(() => { setEditandoArray(false) }) })
                    .catch((err) => { console.log(err) })
            }
        }
    }

    function handleDrop(dropIndex) {
        if (dragIndex === null || dragIndex === dropIndex) return // si lo soltaste en el mismo o si no hiciste nada

        let updatedBebidas = [...bebidas] // copia de las bebidas para trabajar en ella no en el estado

        let [movedItem] = updatedBebidas.splice(dragIndex, 1) // quita el elemento que se movio y lo guarda en un array de 1

        updatedBebidas.splice(dropIndex, 0, movedItem);  // inserto el elemento en la nueva posicion en el array

        setBebidas(updatedBebidas); // actualizo el estado

        setDragIndex(null); // limpiar estado para el siguiente drag
    };

    useEffect(() => {
        if (user1?.id) {
            getBebidas();
        }
    }, [user1]);

    return (
        <>
            {/* Modal para ver la foto */}
            {/* <CModal visible={visible} onClose={() => setVisible(false)}>
                <CModalHeader>Foto bebida</CModalHeader>

                <CModalBody>
                    <div style={{ textAlign: 'center' }}>
                        <img src={fotoModal} style={{ width: '25%' }} />  <br />  <br />
                    </div>
                </CModalBody>

            </CModal> */}

            {/* Modal para insertar bebida */}
            <CModal visible={visible2} onClose={() => setVisible2(false)}>

                <CModalBody>
                    <InsertBebida setVisible2={setVisible2} bebidas={bebidas} setBebidas={setBebidas} bebidasOG={bebidasOG} setBebidasOG={setBebidasOG} user1={user1} allDrinks={allDrinks} />
                </CModalBody>

            </CModal>

            {/* Modal para editar bebida */}
            <CModal visible={visible3} onClose={() => setVisible3(false)}>

                <CModalBody>
                    <EditBebida setVisible3={setVisible3} infoEdit={infoEdit} setInfoEdit={setInfoEdit} infoEditOG={infoEditOG} arrayContiene={bebidas} setArrayContiene={setBebidas} arrayContieneOG={bebidasOG} setArrayContieneOG={setBebidasOG} />
                </CModalBody>

            </CModal>

            <div className='centro'>

                <center>
                    <CFormInput style={{ "width": "30%" }} type="text" id="floatingInput" label="Buscador" placeholder='Buscar' onChange={((e) => { handleChange(e.target.value) })} />
                </center>

                <br />

                <div style={{ textAlign: 'center' }}>

                    <h5>{bebidas.length} bebidas registradas</h5>

                </div>

                {
                    user1.role == 'restaurant' &&
                    <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', gap: '10px' }}>
                        <CButton color='success' style={{ paddingInline: "25px" }} className='boton' onClick={() => setVisible2(true)}>Agregar bebida</CButton>
                        <CButton color={editandoArray ? 'info' : 'success'} onClick={() => { setEditandoArray(!editandoArray); !editandoArray ? null : handleUpdateOrder() }}>{editandoArray ? "Guardar cambios" : "Ordenar bebidas"}</CButton>
                    </div>
                }

                <br />

                {
                    !loading ?
                        bebidas.length == 0 ?
                            <div style={{ textAlign: 'center' }}><h1>No hay bebidas registradas</h1></div>
                            :
                            <>
                                <CTable style={{ width: '80%', margin: 'auto' }} responsive color="dark" hover>
                                    <CTableHead>
                                        <CTableRow color='info'>
                                            {/* <CTableHeaderCell className='cells'>Foto</CTableHeaderCell> */}
                                            <CTableHeaderCell className='cells'>Tipo</CTableHeaderCell>
                                            <CTableHeaderCell className='cells'>Nombre</CTableHeaderCell>
                                            <CTableHeaderCell className='cells'>Precio</CTableHeaderCell>
                                            <CTableHeaderCell className='cells'>Descripción</CTableHeaderCell>
                                            <CTableHeaderCell className='cells'>Editar</CTableHeaderCell>
                                            <CTableHeaderCell className='cells'></CTableHeaderCell>
                                        </CTableRow>
                                    </CTableHead>

                                    <CTableBody>
                                        {
                                            bebidas?.length > 0 ?
                                                <>
                                                    {
                                                        bebidas.map((item, index) => {
                                                            return (


                                                                <CTableRow key={item._id}
                                                                    draggable={editandoArray ? true : false}
                                                                    onDragStart={() => setDragIndex(index)}
                                                                    onDragOver={(e) => e.preventDefault()} // Si no, no funciona el drop
                                                                    onDrop={() => handleDrop(index)}
                                                                >
                                                                    {/* <CTableDataCell className='cells'>
                                                                        <img src={`https://res.cloudinary.com/activecode/image/upload/f_auto,q_auto/bebbo/drinks/drink${item?._id}.jpg`} style={{ width: '100px' }} />
                                                                    </CTableDataCell> */}
                                                                    <CTableDataCell className='cells'>{item.type.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}</CTableDataCell>

                                                                    <CTableDataCell className='cells'>{item.name.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}</CTableDataCell>

                                                                    <CTableDataCell className='cells'>{item.price}</CTableDataCell>

                                                                    <CTableDataCell className='cellsGrande'>{item.description.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}</CTableDataCell>

                                                                    <>
                                                                        <CTableDataCell className='cells'>

                                                                            <CTooltip content="Editar">
                                                                                <CButton
                                                                                    style={{ marginRight: '10px' }}
                                                                                    color='success'
                                                                                    onClick={() => { setInfoEdit(item); setInfoEditOG(item); setVisible3(true) }}
                                                                                >
                                                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                                                </CButton>
                                                                            </CTooltip>

                                                                            {
                                                                                user1.role == 'restaurant' &&
                                                                                <CTooltip content="Cambiar status bebida">
                                                                                    <CButton
                                                                                        color={item.isActive ? 'success' : 'danger'}
                                                                                        onClick={() => statusBebida(item, !item.isActive)}
                                                                                    >
                                                                                        {
                                                                                            item.isActive ?
                                                                                                <i className="fa-solid fa-eye"></i>
                                                                                                :
                                                                                                <i className="fa-solid fa-eye-slash"></i>
                                                                                        }
                                                                                    </CButton>
                                                                                </CTooltip>
                                                                            }

                                                                        </CTableDataCell>
                                                                        <CTableDataCell>{editandoArray ? <i className="fa-solid fa-bars"></i> : ''}</CTableDataCell>
                                                                    </>
                                                                </CTableRow>
                                                            )
                                                        })
                                                    }
                                                </>

                                                :
                                                <>
                                                    <CTableRow>
                                                        <CTableDataCell colSpan="11">Sin Resultados</CTableDataCell>
                                                    </CTableRow>
                                                </>
                                        }
                                    </CTableBody>
                                </CTable>
                            </>
                        : <><div className='loading'><ReactLoading type={'spin'} color={'cornflowerblue'} height={'5vw'} width={'5vw'} /></div></>
                }

                <br />

            </div>
        </>
    )
}

export default Bebidas
